import React, {useEffect, useRef} from "react";

import {observer} from "mobx-react";
import classNames from "classnames";
import styles from "../styles/new-search-widget.module.scss";
import {NEW_SEARCH_WIDGET} from "../new-search-widget.consts";
import {SEARCH_WIDGET} from "../../search-widget/search-widget-consts";
import {SITE_HEADER_MODULE} from "../../../apps/website/modules/site-header-module/site-header-module.consts";
import {SearchImageRequestParams} from "../../../core/icons/search.image-request-params";
import {useThemeColor} from "../../../infrastructure/hooks/useThemeColor";
import {COLORS} from "../../../core/app/consts/colors";
import {SVGImage} from "../../../core/components/image/svg-image";
import {NewSearchWidgetLoader} from "./new-search-widget.loader";

export const NewSearchWidgetInput = observer(({controller}) => {
  const {state, device, terms, config} = controller;
  const {SEARCH_INSTRUCTIVE_TEXT_NEW_MOBILE, SEARCH_INSTRUCTIVE_TEXT_NEW_DESKTOP} = terms;
  const {isSmallView} = device;
  const {source} = config;
  const {query, isSearchVisible, isSportTypesDropdownActiveNavigation} = state;

  const inputRef = useRef(null);

  useEffect(() => {
    if(isSearchVisible) {
      controller.action(NEW_SEARCH_WIDGET.ACTION_TYPES.FETCH.onSportTypesFetch);
      !isSmallView && inputRef.current.focus();
    }

    isSportTypesDropdownActiveNavigation ? inputRef.current?.blur() : inputRef.current.focus()
  }, [isSearchVisible, isSportTypesDropdownActiveNavigation])

  const containerProps = {
    className: classNames(styles.input_container),
    onClick: ()=> controller.action(NEW_SEARCH_WIDGET.ACTION_TYPES.CLICK.onTabClick, {reset: true})
  }

  const searchInputProps = {
    className: classNames(styles.input),
    onFocus: () => controller.action(SEARCH_WIDGET.ANALYTICS.ACTION_TYPES.onSearchClickEvent, {source: source}),
    onChange: (event) => controller.action(NEW_SEARCH_WIDGET.ACTION_TYPES.CLICK.onChangeQuery, {query: event.target.value}),
    maxLength: NEW_SEARCH_WIDGET.maximumCharacters,
    placeholder: isSmallView ? SEARCH_INSTRUCTIVE_TEXT_NEW_MOBILE : SEARCH_INSTRUCTIVE_TEXT_NEW_DESKTOP,
    value: query ?? '',
    ref: inputRef
  };

  const iconSize: Number = isSmallView ? SITE_HEADER_MODULE.SEARCH_ICON_SIZE.mobile : SITE_HEADER_MODULE.SEARCH_ICON_SIZE.desktop
  const iconColor: Number = useThemeColor(COLORS.textPrimary)

  const searchIconProps = {
    src: new SearchImageRequestParams(iconSize, iconSize),
    className: classNames(styles.search_icon),
    fillcolor: iconColor
  };

  return (
    <div {...containerProps}>
      <SVGImage {...searchIconProps}/>
      <input {...searchInputProps}/>
      <NewSearchWidgetLoader controller={controller}/>
    </div>
  )
});
